<template>
  <div>
    <div class="task-item" v-if="showDone || (!showDone && item.is_done == 0)">
      <div class="name-con">
        <svg-icon icon-class="drag" @mousedown="dragStart(item.id)" class="icon-drag"></svg-icon>
        <!--        <vab-remix-icon icon-class="drag"-->
        <!--                        @mousedown="dragStart(item.id)"-->
        <!--                        class="ver-middle pointer icon-drag"/>-->
        <div class="span-level1" v-if="item.level == 1"></div>
        <div class="span-level2" v-if="item.level == 2"></div>

        <i v-if="item.child.length > 0 && isOpen == true" class="el-icon-caret-bottom arrow flex"
           @click="isOpen = false"></i>
        <i v-if="item.child.length > 0 && isOpen == false" class="el-icon-caret-right arrow flex"
           @click="isOpen = true"></i>
        <div class="arrow" v-if="item.child.length == 0"></div>

        <svg-icon  v-if="item.is_done == 1" icon-class="circle-done"  class="ver-middle pointer icon-circle-done" @click="completeTask(0)"></svg-icon>

<!--        <vab-remix-icon v-if="item.is_done == 1" icon-class="circle-done"-->
        <!--                        class="ver-middle pointer icon-circle-done" @click="completeTask(0)"/>-->
        <div class="circle" @click="completeTask(1)" v-else></div>

        <el-input v-if="isEdit" class="name name-input" v-model="item.name" ref="nameInput" @blur="editName"
                  @keyup.native.enter="editName"></el-input>
        <div v-else class="name name-label" :class="item.is_done ? 'is-done' : ''" @click="showEdit">{{
            item.name
          }}
        </div>
        <div class="icon-right">
          <svg-icon icon-class="robot" v-if="item.level <2"
                    @click="showAiTask"></svg-icon>
          <el-popover placement="bottom-start"
                      ref="morePopover"
                      title=""
                      width="240"
                      :visible-arrow="false"
                      popper-class="pm-popper-task-more"
                      trigger="click"
                      content="">
            <div slot="reference">
              <div class="more">
                <svg-icon icon-class="more"></svg-icon>
              </div>

              <!--              <vab-remix-icon icon-class="more"-->
              <!--                              class="ver-middle fz-18 pointer m-r-12  m-l-10"/>-->
            </div>
            <div class="popper_all">
              <div class="btn-item pop-ai-btn" @click="showAiTask" v-if="item.level <2">
                <svg-icon icon-class="robot"></svg-icon>
                <div class="label label-ai">AI 任务分解</div>
              </div>
              <div class="line" v-if="item.level <2"></div>
              <div class="btn-item" @click="showAdd(item.id, item.level + 1)" v-if="item.level <2">
                <img src="../../../assets/images/git-merge.png" class="icon">
                <div class="label">添加子任务</div>
              </div>
              <div class="btn-item" @click="showAdd(item.pid, item.level)">
                <img src="../../../assets/images/next-add.png" class="icon">
                <div class="label">在下一行添加新任务</div>
              </div>
              <div class="btn-item" v-if="item.level > 0" @click="upLevel">
                <img src="../../../assets/images/up-level.png" class="icon">
                <div class="label">
                  升级任务
                </div>
              </div>
              <div class="btn-item" v-if="item.level < 2 && index >0" @click.stop="downLevel">
                <img src="../../../assets/images/reduce-level.png" class="icon">
                <div class="label">
                  降级任务
                </div>
              </div>
              <div class="line"></div>
              <div class="btn-item m-b-8" @click="deleteOne">
                <img src="../../../assets/images/trash.png" class="icon">
                <div class="label l-h-32">
                  删除任务
                </div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="date-con">
        <div class="s-date">
          <el-date-picker
              v-model="item.start_date"
              prefix-icon="ss"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              placeholder="起始日期"
              @change="editSDate"
              type="date">
          </el-date-picker>
        </div>
        <div class="e-date">
          <el-date-picker
              v-model="item.end_date"
              prefix-icon="ss"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              placeholder="截止日期"
              @change="editEDate"
              type="date"></el-date-picker>
        </div>
      </div>
    </div>
    <plan-master-add v-if="isShowAdd" ref="refAdd" @save="save" :pid="curPid" :level="addLevel"
                     @freshList="emitFreshList"></plan-master-add>
    <!-- 遍历子任务 -->
    <template
        v-if="item.child && item.child.length > 0 && isOpen == true && ( showDone || ( !showDone && item.is_done == 0) )   ">
      <draggable
          v-model="item.child"
          :animation="300"
          :key="item.id"
          group="task"
          :sort='true'
          handle=".icon-drag">
        <transition-group>
          <task-item v-for="(child, ind) in item.child" :item="child" :index="ind" :uuid="uuid" :showDone="showDone"
                     :key="child.id"
                     @save="emitSave" @freshList="emitFreshList" @dragStart="dragStart">
          </task-item>
        </transition-group>
      </draggable>
    </template>
    <!-- AI 分解任务 -->
    <task-ai ref="taskAi" @freshList="emitFreshList" :uuid="uuid"></task-ai>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import planMasterAdd from './plan-master-add'
import taskAi from './plan-task-ai'
import {edit, delOne, upLevel, downLevel, complete} from '@/api/planMaster'

export default {
  name: 'task-item',
  components: {planMasterAdd, draggable, taskAi},
  props: ['item', 'index', 'showDone', 'uuid'],
  data() {
    return {
      isShowAdd: false,
      curPid: 0,
      isOpen: true,
      addLevel: '',
      isEdit: false,
    }
  },
  methods: {
    getUuid() {
      if (this.uuid == '' || this.uuid == null) {
        this.uuid = localStorage.getItem('pm-uuid')
      }
    },
    //新建任务
    showAdd(pid, level) {
      this.isShowAdd = true;
      this.curPid = pid
      this.addLevel = level
      this.$refs.morePopover.doClose()
      this.$nextTick(() => {
        this.$refs.refAdd.focus()
      })
    },
    showEdit() {
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs.nameInput.focus()
      })
    },
    emitSave(name, pid) {
      this.$emit('save', name, pid);
      this.isShowAdd = false
    },
    emitFreshList() {
      this.$emit('freshList');
    },
    save(name) {
      this.$emit('save', name, this.curPid);
      this.isShowAdd = false
    },
    editName() {
      if (this.item.name == '') {
        return this.$message({
          message: '任务名称不能为空',
          type: 'error'
        })
      }
      console.log('uuid=' + this.uuid)
      edit({id: this.item.id, field: 'name', value: this.item.name}, this.uuid).then((res) => {
        this.isEdit = false
      })
    },
    editSDate(e) {
      console.log(e)
      edit({id: this.item.id, field: 'start_date', value: e}, this.uuid).then((res) => {

      }).catch(err => {
        this.item.start_date = ''
        return this.$message({
          message: err.msg,
          type: 'error'
        })
      })
    },
    editEDate(e) {
      edit({id: this.item.id, field: 'end_date', value: e}, this.uuid).then((res) => {

      }).catch(err => {
        this.item.end_date = ''
        return this.$message({
          message: err.msg,
          type: 'error'
        })
      })
    },
    //删除
    deleteOne() {
      this.delOne()
    },
    delOne() {
      delOne({id: this.item.id}, this.uuid).then((res) => {
        this.$emit('freshList');
      })
    },
    //升级任务
    upLevel() {
      upLevel({id: this.item.id}, this.uuid).then((res) => {
        this.$emit('freshList');
      })
    },
    //降级任务
    downLevel() {
      downLevel({id: this.item.id}, this.uuid).then((res) => {
        this.$emit('freshList');
      })
    },
    //完成任务
    completeTask(status) {
      complete({id: this.item.id, is_done: status}, this.uuid).then((res) => {
        this.item.is_done = status
      })
    },
    // 拖拽开始 set 当前任务id
    dragStart(id) {
      this.$emit('dragStart', id);
    },
    // ai 分解任务
    showAiTask() {
      let item = this.item
      this.$refs.taskAi.show(item.id, item.name, item.start_date, item.end_date, 0, '')
    },
  },
  computed: {}
}
</script>
<style lang="less">

.pm-popper-task-more {
  padding: 0;
  font-size: 13px;

  .line {
    height: 0.5px;
    background: #D6D8DC;
    margin: 8px 0;
  }

  .btn-item {
    display: flex;
    flex-flow: row;
    height: 32px;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #F4F6FA;
    }

    .icon {
      width: 20px;
      height: 20px;
      margin-left: 16px;
      margin-right: 12px;
    }

    .label-ai {
      color: #704FF9;
    }

    &.pop-ai-btn {
      margin: 8px 0 0 0;

      .svg-icon {
        width: 20px;
        height: 20px;
        margin-left: 16px;
        margin-right: 12px;
      }
    }
  }

}

</style>
<style lang="less" scoped>
.more {
  margin: 0 12px 0 10px;
  cursor: pointer;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-item {
  width: 100%;
  border-bottom: 0.5px solid #F0F0F0;
  display: flex;
  align-items: center;

  &:hover {
    background: var(--bglight, #F6F7FB);
  }

  &:hover .icon-right {
    display: flex !important;
    align-items: center;
  }

  &:hover .name.name-label {
    //display: none !important;
  }

  &:hover .name.name-input {
    //display: flex !important;
  }

  &:hover .icon-drag {
    opacity: 1 !important;
  }

  &:hover /deep/ .el-date-editor {
    .el-input__inner {
      &::placeholder {
        color: #ADB1BA !important;
      }
    }
  }

  .name-con {
    display: flex;
    flex: 1;
    align-items: center;
    padding: 10px 0;
    border-right: 0.5px solid #E2E4E9;

    .span-level1 {
      width: 24px;
    }

    .span-level2 {
      width: 48px;
    }

    .icon-drag {
      width: 20px;
      height: 20px;
      opacity: 0;
    }

    .icon-circle-done {
      width: 20px;
      height: 20px;
      margin: 0 12px 0 8px;
    }

    .circle {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #B5B5B5;
      box-sizing: border-box;
      margin: 0 12px 0 8px;
      cursor: pointer;
    }

    .el-icon-caret-bottom, .el-icon-caret-right {
      color: #787D86;
      font-size: 12px;
      cursor: pointer;
    }

    .arrow {
      width: 16px;
      height: 16px;
      margin: 0 0 0 8px;
    }

    .name {
      flex: 1;
      box-sizing: border-box;
      cursor: pointer;

      &.name-label {
        padding: 0 8px 0 4px;
        line-height: 28px;
      }

      &.name-label.is-done {
        color: #ADB1BA;
      }

      &.name-input {
        display: flex;
      }
    }

    /deep/ .el-input--small .el-input__inner {
      border: none;
      padding: 0 0 0 4px;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: #10141B;
    }

    .icon-right {
      display: none;
      margin-left: 10px;

      .svg-icon {
        cursor: pointer;
      }

      .icon-ai {
        width: 20px;
        height: 20px;
      }
    }
  }

  .date-con {
    width: 300px;
    display: flex;
    align-items: center;

    .s-date, .e-date {
      width: 110px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .s-date {
      margin: 0 10px 0 12px;
    }

    /deep/ .el-date-editor .el-input__inner {
      //background: #F6F7FB;
    }

    /deep/ .el-date-editor {

      .el-input__inner {
        padding: 0 0 0 4px;
        text-align: left;
        border: none;
        box-sizing: border-box;
        color: #10141B;
        font-size: 14px;

        &::placeholder {
          color: #fff;
        }
      }

    }

  }
}


</style>